import API from "./Api";
// import Csrf from "./Csrf";

export default {

  async enrolled(form){
    return API.post("courseassignment/enrolled", form);
  }

}